module.exports = __webpack_public_path__ + "ae4ca209b1adf936771f1aabcb4b2a04.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-mediumitalic.woff
 ** module id = 14
 ** module chunks = 0
 **/